'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var DynamicLayout = require('@narvar/nth-kit-dynamic-layout');
var styled = require('styled-components');
var index$5 = require('../../packs/OrderLookup/index.js');
var index$3 = require('../../packs/ItemSelector/index.js');
var index$2 = require('../../packs/ReturnReasons/index.js');
require('../../packs/Pudo/RootElm/PudoRaw.js');
var wrapped = require('../../packs/Pudo/RootElm/wrapped.js');
var index$1 = require('../../packs/ReviewSummary/index.js');
var index = require('../../packs/Confirmation/index.js');
require('@babel/runtime/helpers/extends');
require('../../packs/RefundMethods/raw.js');
require('react-query');
require('@narvar/nth-hook-loma');
require('@narvar/nth-hook-global-settings');
require('@narvar/nth-bit-error-boundary');
require('@apollo/client');
require('@apollo/client/link/error');
require('@narvar/apollo-client');
require('@narvar/nth-hook-translations');
require('@narvar/nth-hook-settings');
require('@narvar/nth-hook-theme');
require('@narvar/nth-hook-context-analytics');
require('jwt-decode');
var NthFeature = require('./NthFeature.js');
var index$4 = require('../../components/CsrSignInForm/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var DynamicLayout__default = /*#__PURE__*/_interopDefaultLegacy(DynamicLayout);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

/* eslint-disable react/prop-types */
const View = props => {
  if (!props) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
  const {
    children
  } = props;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children);
};
const PageWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-1lfkkhb-0"
})(["overflow-x:hidden;"]);
const HeightWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-1lfkkhb-1"
})(["min-height:calc(100vh - 250px);"]);
const DesktopHeightWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-1lfkkhb-2"
})(["@media screen and (min-width:768px){min-height:calc(100vh - 250px);}"]);
const ReturnsLayout = _ref => {
  let {
    orderLookup,
    itemSelector,
    returnReasons,
    pudo,
    review,
    confirmation
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(PageWrapper, null, /*#__PURE__*/React__default["default"].createElement(DynamicLayout__default["default"], {
    fixedSize: true,
    view: View,
    feature: props => {
      if (!props) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
      const {
        node
      } = props;
      switch (node.name) {
        case 'Order Lookup Pack':
          if (!orderLookup) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
          if (orderLookup !== null && orderLookup !== void 0 && orderLookup.error) {
            const isCsrSignIn = index$4.getSessionStorageItem('csrSignIn') === 'true';
            if (isCsrSignIn) {
              index$4.setSessionStorageItem('csrSignIn', null);
              window.location.href = `${window.location.origin}${window.location.pathname}/csr-login?error_code=500`;
              return /*#__PURE__*/React__default["default"].createElement(DesktopHeightWrapper, null);
            }
          }
          return /*#__PURE__*/React__default["default"].createElement(DynamicLayout__default["default"], {
            fixedSize: true,
            view: View,
            transformLayout: () => {
              var _node$options, _node$options$customF, _node$options$customF2;
              return (_node$options = node.options) === null || _node$options === void 0 ? void 0 : (_node$options$customF = _node$options.customFeature) === null || _node$options$customF === void 0 ? void 0 : (_node$options$customF2 = _node$options$customF.settings) === null || _node$options$customF2 === void 0 ? void 0 : _node$options$customF2.trackPageLayout;
            },
            feature: props => {
              if (!props) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
              const {
                node
              } = props;
              switch (node.name) {
                case 'Order Lookup Form':
                  return /*#__PURE__*/React__default["default"].createElement(DesktopHeightWrapper, null, /*#__PURE__*/React__default["default"].createElement(index$5.OrderLookup, orderLookup));
                default:
                  return /*#__PURE__*/React__default["default"].createElement(NthFeature["default"], {
                    node: node,
                    sticky: true
                  });
              }
            }
          });
        case 'Item Selector Pack':
          if (!itemSelector) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
          return /*#__PURE__*/React__default["default"].createElement(HeightWrapper, null, /*#__PURE__*/React__default["default"].createElement(index$3.ItemSelector, itemSelector));
        case 'Return Reasons Pack':
          if (!returnReasons) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
          return /*#__PURE__*/React__default["default"].createElement(HeightWrapper, null, /*#__PURE__*/React__default["default"].createElement(index$2.ReturnReasons, returnReasons));
        case 'Pudo Pack':
          if (!pudo) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
          return /*#__PURE__*/React__default["default"].createElement(HeightWrapper, null, /*#__PURE__*/React__default["default"].createElement(wrapped.Pudo, pudo));
        case 'Review Summary Pack':
          if (!review) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
          return /*#__PURE__*/React__default["default"].createElement(HeightWrapper, null, /*#__PURE__*/React__default["default"].createElement(index$1.ReviewSummary, review));
        case 'Confirmation Pack':
          if (!confirmation) return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
          return /*#__PURE__*/React__default["default"].createElement(HeightWrapper, null, /*#__PURE__*/React__default["default"].createElement(index.Confirmation, confirmation));
        default:
          return /*#__PURE__*/React__default["default"].createElement(NthFeature["default"], {
            node: node,
            sticky: Boolean(orderLookup)
          });
      }
    }
  }));
};
/* eslint-enable react/prop-types */

exports["default"] = ReturnsLayout;
